//AJAX 프레임
import { ajaxFrame } from '../controller/assets/lib/ajaxForm';
//페이지로딩 인터렉션
import { AjaxLoading } from '../actions/Interactions/loading.js';
//Header, Footer Call
export const baseFrame = {
	init:function(param) {
		if(param != '/member/login') {
			$('#header, #aside, #footer').show();
			ajaxFrame.ajaxHtmlCall('#aside','GET','/layout/aside.html','html', true);
		}else{
			$('#header, #aside, #footer').hide();
		}
	}
}





// WEBPACK FOOTER //
// ./js/layout/layout.js